var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header_toggle_menu"}},[_c('button',{staticClass:"hamburger hamburger--collapse",class:_vm.$store.state.menu ? 'is-active' : '',attrs:{"type":"button"},on:{"click":function($event){return _vm.$store.dispatch('toggleMenu')}}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hamburger-box"},[_c('span',{staticClass:"hamburger-inner"})])
}]

export { render, staticRenderFns }